import { NAV_LINKS, LOGO_IMG } from "@/lib/site-data";

export const Footer = () => {
  const go = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="relative overflow-hidden border-t border-avatar-ink/10 pt-20">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="grid grid-cols-1 gap-12 pb-16 md:grid-cols-[1.5fr_1fr_1fr]">
          <div>
            <img src={LOGO_IMG} alt="Avatar India" className="h-9 w-auto" />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-avatar-ink/50">
              The smart water tanks for modern homes. Strong outside, pure inside —
              engineered to last.
            </p>
          </div>

          <div>
            <div className="mb-5 text-xs font-medium uppercase tracking-[0.2em] text-avatar-ink/40">Explore</div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} onClick={(e) => go(e, l.href)} className="text-sm text-avatar-ink/70 transition-colors hover:text-avatar-gold">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="mb-5 text-xs font-medium uppercase tracking-[0.2em] text-avatar-ink/40">Get in touch</div>
            <ul className="space-y-3 text-sm text-avatar-ink/70">
              <li><a href="mailto:avatarindustries@gmail.com" className="transition-colors hover:text-avatar-gold">avatarindustries@gmail.com</a></li>
              <li><a href="https://www.avatarwatertanks.in" className="transition-colors hover:text-avatar-gold">www.avatarwatertanks.in</a></li>
              <li><a href="https://instagram.com/avatar.india_" className="transition-colors hover:text-avatar-gold">@avatar.india_</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="select-none px-4 pb-6 text-center leading-none">
        <div className="font-heading font-bold tracking-tighter text-avatar-ink/[0.06]" style={{ fontSize: "18vw" }}>
          AVATAR
        </div>
      </div>

      <div className="border-t border-avatar-ink/10 py-6">
        <div className="mx-auto flex max-w-[1400px] flex-col items-center justify-between gap-2 px-6 text-xs text-avatar-ink/40 md:flex-row lg:px-12">
          <span>© {new Date().getFullYear()} Avatar Group of Companies. All rights reserved.</span>
          <span>ISO Certified · Built with Trust. Engineered to Last.</span>
        </div>
      </div>
    </footer>
  );
};
